export const fetchAll = 'fetchAll'
export const fetch = 'fetch'
export const store = 'store'
export const update = 'update'
export const remove = 'remove'
